import { showSSOButtons } from "@faire/deprecated-retailer-visitor-shared/lib/ssoUtils";
import { SocialSignOnProvider } from "@faire/web-api--source/indigofair/data/SocialSignOnProvider";
import { getDocument } from "@faire/web/common/globals/getDocument";
import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { loadScript } from "@faire/web/common/loadScript";
import { logError } from "@faire/web/common/logging";
import { faireBaseUrl } from "@faire/web/common/routes/faireBaseUrl";

const APPLE_LOGIN_SCRIPT_NAME = "_appleLogin";
const APPLE_LOGIN_SCRIPT_SRC =
  "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";

const DEFAULT_CLIENT_ID = "com.faire.retailer";
const SCOPE = "name email";

const PROVIDER = SocialSignOnProvider.APPLE;

export const isAppleScriptLoaded = () =>
  !!getDocument()?.getElementById(APPLE_LOGIN_SCRIPT_NAME);

export const loadAppleLoginScript = async () => {
  if (!isAppleScriptLoaded() && showSSOButtons()) {
    await loadScript(APPLE_LOGIN_SCRIPT_SRC, APPLE_LOGIN_SCRIPT_NAME);
  }
};

export const initializeAppleLogin = (
  appleSignInClientId: string,
  setSSOLocalizedMessage: () => void
) => {
  try {
    const windowObj = getWindowOrThrow();
    if (
      windowObj?.AppleID?.auth &&
      typeof windowObj?.AppleID?.auth.init === "function"
    ) {
      AppleID.auth.init({
        clientId: appleSignInClientId ?? DEFAULT_CLIENT_ID,
        scope: SCOPE,
        redirectURI: faireBaseUrl(),
        usePopup: true,
      });
    }
  } catch (error) {
    logError(error, {
      tags: {
        signInType: "SSO",
        provider: PROVIDER,
        code: "auth_init_failed",
      },
    });
    setSSOLocalizedMessage();
  }
};
